import React, { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
export const DelayedContent = /*#__PURE__*/forwardRef(({
  children,
  deferTimeout,
  className
}, ref) => (/*#__PURE__*/React.createElement("div", {
  ref: ref,
  className: clsx(styles.delayedContent, className),
  style: {
    ...(deferTimeout && {
      '--delayedContent_deferTimeout': deferTimeout
    })
  }
}, children)));